export enum COLOR {
  GREEN = 'green',
  BLUE = 'blue',
  WHITE = 'white',
  WHITE_GREEN = 'white-green',
  ORANGE = 'orange',
}
